import List from 'components/Common/List'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import Modal from 'components/Luxkit/Modal/Modal'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { sortBy } from 'lib/array/arrayUtils'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import AccommodationRoomDetailsList from './AccommodationRoomDetailsList'

const AmenityList = styled(List)`
  margin-top: 0;

  ${mediaQueryUp.tablet} {
    columns: 2;
  }
`

interface Props {
  roomPackage: App.HotelPackage
}

function AccommodationAmenitiesAndPoliciesModal(props: Props) {
  const { roomPackage } = props
  const sortedAmenities = useMemo(() => sortBy(roomPackage.roomType.amenities, a => a.name, 'asc'), [roomPackage.roomType])

  return <Modal
    title="Room amenities & policies"
    subtitle={roomPackage.roomType.name}
  >
    <Group direction="vertical" gap={20}>
      <Group direction="vertical" gap={12}>
        <Heading variant="heading6">Room Details</Heading>
        <AccommodationRoomDetailsList packageRoomType={roomPackage.roomType} />
      </Group>
      {!!sortedAmenities.length && <Group direction="vertical" gap={12}>
        <Heading variant="heading6">Room Amenities</Heading>
        <AmenityList>
          {sortedAmenities.map(amenity => <BodyText
            key={amenity.id}
            as="li"
            variant="medium"
          >
            {amenity.name}
          </BodyText>)}
        </AmenityList>
      </Group>}
      {roomPackage.roomPolicyDescription && <Group direction="vertical" gap={12}>
        <Heading variant="heading6">Room Policies</Heading>
        <MarkdownRender content={roomPackage.roomPolicyDescription} type="compact" />
      </Group>}
    </Group>
  </Modal>
}

export default AccommodationAmenitiesAndPoliciesModal
